
/*
    wrapper for the BusOpsPage component for reassigned trips,
    passes the data context information through to
    facilitate data reloads
*/

import React, {useContext} from "react";

import DataContext from "../DataContext";

import BusOpsPage from "./BusOpsPage";

const BusOpsReassignedPage = (props) => {
    const context = useContext(DataContext);

    console.log("Busops reassigned context", context);

    return (
        <BusOpsPage mode="REASSIGNED" {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
            showExternalChange={context.showExternalChange}
        />
    )
}

export default BusOpsReassignedPage;